/**
 * GDix OpenAPI
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @Version 1.0.2
/* tslint:disable:no-unused-variable member-ordering */
type ValidProps = '_links' | 'result'
interface IStringIndex extends Record<ValidProps, any> {}
interface IAuthorizationHeader {
   Authorization?: string
}

export enum DPSAPI {
   ERROR = 'ERROR',
   INVOKEBACKEND = 'GET_VERSION',
   INVOKEBACKENDPARAM = 'BACKEND',
   AUTHEXTERNUSER = 'UserExtern',
   HEADER_AUTH = 'Authorization',
   HEADER_AUTH_PREFIX = 'Bearer ',
   SESSIONINFO_KEY_ACCESS = 'accesstoken',
   ERROR_EXCEPTION_401 = 'HTTP Status Code: 401',
   ERROR_EXCEPTION_401_URL = 'Authorization/Change/Password',
   ERROR_EXCEPTION_500 = 'HTTP Status Code: 500',
   ERROR_EXCEPTION_500_URL = 'Authorization/Logout'
}

import { Inject, Injectable, Optional, Injector }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParameterCodec }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { GETResponseV2ExternDesignColorPagination } from '../model/models';
import { ResponseV2ExternDesignColor } from '../model/models';
import { GETResponseV2ExternDesignConfigPagination } from '../model/models';
import { ResponseV2ExternDesignConfig } from '../model/models';
import { GETResponseV2ExternDesignTextPagination } from '../model/models';
import { ResponseV2ExternDesignText } from '../model/models';
import { GETResponseV2ExternDesignTypographyPagination } from '../model/models';
import { ResponseV2ExternDesignTypography } from '../model/models';
import { GETResponseV2InternDesignColorPagination } from '../model/models';
import { ResponseV2InternDesignColor } from '../model/models';
import { GETResponseV2InternDesignConfigPagination } from '../model/models';
import { ResponseV2InternDesignConfig } from '../model/models';
import { GETResponseV2InternDesignTextPagination } from '../model/models';
import { ResponseV2InternDesignText } from '../model/models';
import { GETResponseV2InternDesignTypographyPagination } from '../model/models';
import { ResponseV2InternDesignTypography } from '../model/models';
import { POSTDPSVersionV1Response } from '../model/models';
import { ResponseDesignVersion } from '../model/models';

import { BASE_PATH }                     from '../variables';
import { Configuration }                                     from '../configuration';

import { ErrorOpenApiService } from 'src/app/shared/services/errorHandler/error-openapi.service' 
import { EMPTY, Observable, from, of, reduce  } from 'rxjs';
import { expand, scan, catchError, map, switchMap, tap, takeWhile, first } from 'rxjs/operators';

declare var dps_api: any; 
declare var uuid: any;

'19.08.2025 11:38:56'



@Injectable({
  providedIn: 'root'
})
export class DefaultService {

   protected basePath = 'http://localhost:8080/API/OAS';
   public defaultHeaders = new HttpHeaders();
   public configuration = new Configuration();
   public encoder: HttpParameterCodec;

   constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration, private injector: Injector) {
      if (configuration) {
         this.configuration = configuration;
      }
      if (typeof this.configuration.basePath !== 'string') {
         if (typeof basePath !== 'string') {
            basePath = this.basePath;
         }
         this.configuration.basePath = basePath;
      }
      this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
   }

   public async Connected () {
      if(this.isUuid()) await dps_api.connect_async(); 
   }

   public isConnected(): boolean {
      return dps_api.is_connected()
   }

   public isDpsApi(): boolean {
      return typeof dps_api == 'undefined' ?  false : true
   }
   
   public getBackendVersion(): Observable<string> {
      return  from<Observable<string>>(dps_api.invoke(DPSAPI.INVOKEBACKEND, DPSAPI.INVOKEBACKENDPARAM)).pipe(
         catchError(error => {
            console.log('catchError', error)
            return of('');
         }),
         map((response: string) => response)
      )
   }

   public isUuid(): boolean {
      return typeof uuid == 'undefined' ?  false : true
   }

   /**
   * @param projectname 
   * @param version 
   * @param option 
   * @param page Specifies the page count. More infos see: \&#39;#/components/parameters/Page\&#39;
   * @param limit max count of \&#39;result\&#39; array items. To get the next items see: \&#39;#/components/parameters/Page\&#39;
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */

   public dPSDesignV2ExternCommunicationLoadColorProjectnameVersionOptionGet (identifier: object, payload: object, page?: boolean, pagenr?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<ResponseV2ExternDesignColor[] | string>
   {

      if (payload === null || payload === undefined) {
         throw new Error('Required parameter payload was null or undefined when calling dPSDesignV2ExternCommunicationLoadColorProjectnameVersionOptionGet.');
      }
      if (payload === null || payload === undefined) {
         throw new Error('Required parameter payload was null or undefined when calling dPSDesignV2ExternCommunicationLoadColorProjectnameVersionOptionGet.');
      }
      if (payload === null || payload === undefined) {
         throw new Error('Required parameter payload was null or undefined when calling dPSDesignV2ExternCommunicationLoadColorProjectnameVersionOptionGet.');
      }

 
      let authMethods: string[] = []; 
      authMethods.push("ClientName");
      authMethods.push("Secret");

      const headers = authMethods.filter(elem => elem == DPSAPI.AUTHEXTERNUSER).length > 0 ? {[DPSAPI.HEADER_AUTH]: DPSAPI.HEADER_AUTH_PREFIX + sessionStorage.getItem(DPSAPI.SESSIONINFO_KEY_ACCESS)} : {};
      let save = Object.values(identifier);

      let commandUrl = '/DPS/design/v2/extern/communication/load/color/${this.configuration.encodeParam({name: &quot;projectname&quot;, value: projectname, in: &quot;path&quot;, style: &quot;simple&quot;, explode: false, dataType: &quot;string&quot;, dataFormat: &quot;string&quot;})}/${this.configuration.encodeParam({name: &quot;version&quot;, value: version, in: &quot;path&quot;, style: &quot;simple&quot;, explode: false, dataType: &quot;string&quot;, dataFormat: &quot;string&quot;})}/${this.configuration.encodeParam({name: &quot;option&quot;, value: option, in: &quot;path&quot;, style: &quot;simple&quot;, explode: false, dataType: &quot;string&quot;, dataFormat: &quot;string&quot;})}'; 
      if (commandUrl[0] == '/') {
         commandUrl = commandUrl.substring(1); 
      }
      commandUrl = commandUrl.split('/').map(item => item.includes('${this.configuration.encodeParam') ? save.shift() : item).join('/') 
      commandUrl += `?page=${pagenr ?? '0'}&limit=1000`

      return this._dPSDesignV2ExternCommunicationLoadColorProjectnameVersionOptionGet(commandUrl, headers, payload).pipe (
         map(response => {
            if ((response as IStringIndex)["_links"] && !(response as IStringIndex)['_links']["next"]) return (response as IStringIndex)["result"];
            else return response;
         }),
         expand((response: GETResponseV2ExternDesignColorPagination | string, index) => {      
            if (typeof response == 'string' && response == DPSAPI.ERROR) return of(response);
            const el = response['_links' as keyof typeof response];
            if (el) {
               let nextUrl = el['next' as keyof typeof el] as string | undefined;   
               if (!!nextUrl) return  this._dPSDesignV2ExternCommunicationLoadColorProjectnameVersionOptionGet(nextUrl.split('API/OAS/')[1], headers, payload);
               else if (index == 0) return of((response as IStringIndex)["result"]);
               else return of(response);   
            }
            else return of(response);
         }),
         takeWhile(value => (value as IStringIndex)['_links'] && (value as IStringIndex)['_links']["next"], true),
         reduce((all, current) => { 
            const el = (current as IStringIndex)['_links'];
            if (!!el) {
               if ((all as IStringIndex)['result'] == undefined) (all as IStringIndex)['result' ] = [];
               if (!Array.isArray((all as IStringIndex)['result'])) return Object.assign({}, all, current); 
               else if (!Array.isArray((current as IStringIndex)['result'])) return Object.assign({}, all, current);
               else (all as IStringIndex)['result'].push(...(current as IStringIndex)['result']!)
                  
               return Object.assign([], (all as IStringIndex)["result"]);
            } else return Object.assign({}, all, current);
         }),
         catchError(error => {
            return of('ERROR')
         })   
      )
   }

   private _dPSDesignV2ExternCommunicationLoadColorProjectnameVersionOptionGet (commandUrl: string, headers: IAuthorizationHeader, payload: object): Observable<string | GETResponseV2ExternDesignColorPagination> {
      return from<Observable<string>>(dps_api.invoke("open_api", JSON.stringify({verb: 'get', command: commandUrl, headers: headers, json: JSON.stringify(payload)}),15000)).pipe(
         map(response => JSON.parse(response) as GETResponseV2ExternDesignColorPagination),
         catchError(error => {
            if ((error.indexOf(DPSAPI.ERROR_EXCEPTION_401) != -1 && error.indexOf(DPSAPI.ERROR_EXCEPTION_401_URL) != -1) || (error.indexOf(DPSAPI.ERROR_EXCEPTION_500) != -1 && error.indexOf(DPSAPI.ERROR_EXCEPTION_500_URL) != -1)) {
               throw Error(error);
            }

            const errorOpenApi = this.injector.get(ErrorOpenApiService);
            errorOpenApi.routingCode(error);
            return of(DPSAPI.ERROR);
         })
      )
   }


   /**
   * @param projectname 
   * @param version 
   * @param option 
   * @param page Specifies the page count. More infos see: \&#39;#/components/parameters/Page\&#39;
   * @param limit max count of \&#39;result\&#39; array items. To get the next items see: \&#39;#/components/parameters/Page\&#39;
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */

   public dPSDesignV2ExternCommunicationLoadConfigProjectnameVersionOptionGet (identifier: object, payload: object, page?: boolean, pagenr?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<ResponseV2ExternDesignConfig[] | string>
   {

      if (payload === null || payload === undefined) {
         throw new Error('Required parameter payload was null or undefined when calling dPSDesignV2ExternCommunicationLoadConfigProjectnameVersionOptionGet.');
      }
      if (payload === null || payload === undefined) {
         throw new Error('Required parameter payload was null or undefined when calling dPSDesignV2ExternCommunicationLoadConfigProjectnameVersionOptionGet.');
      }
      if (payload === null || payload === undefined) {
         throw new Error('Required parameter payload was null or undefined when calling dPSDesignV2ExternCommunicationLoadConfigProjectnameVersionOptionGet.');
      }

 
      let authMethods: string[] = []; 
      authMethods.push("ClientName");
      authMethods.push("Secret");

      const headers = authMethods.filter(elem => elem == DPSAPI.AUTHEXTERNUSER).length > 0 ? {[DPSAPI.HEADER_AUTH]: DPSAPI.HEADER_AUTH_PREFIX + sessionStorage.getItem(DPSAPI.SESSIONINFO_KEY_ACCESS)} : {};
      let save = Object.values(identifier);

      let commandUrl = '/DPS/design/v2/extern/communication/load/config/${this.configuration.encodeParam({name: &quot;projectname&quot;, value: projectname, in: &quot;path&quot;, style: &quot;simple&quot;, explode: false, dataType: &quot;string&quot;, dataFormat: &quot;string&quot;})}/${this.configuration.encodeParam({name: &quot;version&quot;, value: version, in: &quot;path&quot;, style: &quot;simple&quot;, explode: false, dataType: &quot;string&quot;, dataFormat: &quot;string&quot;})}/${this.configuration.encodeParam({name: &quot;option&quot;, value: option, in: &quot;path&quot;, style: &quot;simple&quot;, explode: false, dataType: &quot;string&quot;, dataFormat: &quot;string&quot;})}'; 
      if (commandUrl[0] == '/') {
         commandUrl = commandUrl.substring(1); 
      }
      commandUrl = commandUrl.split('/').map(item => item.includes('${this.configuration.encodeParam') ? save.shift() : item).join('/') 
      commandUrl += `?page=${pagenr ?? '0'}&limit=1000`

      return this._dPSDesignV2ExternCommunicationLoadConfigProjectnameVersionOptionGet(commandUrl, headers, payload).pipe (
         map(response => {
            if ((response as IStringIndex)["_links"] && !(response as IStringIndex)['_links']["next"]) return (response as IStringIndex)["result"];
            else return response;
         }),
         expand((response: GETResponseV2ExternDesignConfigPagination | string, index) => {      
            if (typeof response == 'string' && response == DPSAPI.ERROR) return of(response);
            const el = response['_links' as keyof typeof response];
            if (el) {
               let nextUrl = el['next' as keyof typeof el] as string | undefined;   
               if (!!nextUrl) return  this._dPSDesignV2ExternCommunicationLoadConfigProjectnameVersionOptionGet(nextUrl.split('API/OAS/')[1], headers, payload);
               else if (index == 0) return of((response as IStringIndex)["result"]);
               else return of(response);   
            }
            else return of(response);
         }),
         takeWhile(value => (value as IStringIndex)['_links'] && (value as IStringIndex)['_links']["next"], true),
         reduce((all, current) => { 
            const el = (current as IStringIndex)['_links'];
            if (!!el) {
               if ((all as IStringIndex)['result'] == undefined) (all as IStringIndex)['result' ] = [];
               if (!Array.isArray((all as IStringIndex)['result'])) return Object.assign({}, all, current); 
               else if (!Array.isArray((current as IStringIndex)['result'])) return Object.assign({}, all, current);
               else (all as IStringIndex)['result'].push(...(current as IStringIndex)['result']!)
                  
               return Object.assign([], (all as IStringIndex)["result"]);
            } else return Object.assign({}, all, current);
         }),
         catchError(error => {
            return of('ERROR')
         })   
      )
   }

   private _dPSDesignV2ExternCommunicationLoadConfigProjectnameVersionOptionGet (commandUrl: string, headers: IAuthorizationHeader, payload: object): Observable<string | GETResponseV2ExternDesignConfigPagination> {
      return from<Observable<string>>(dps_api.invoke("open_api", JSON.stringify({verb: 'get', command: commandUrl, headers: headers, json: JSON.stringify(payload)}),15000)).pipe(
         map(response => JSON.parse(response) as GETResponseV2ExternDesignConfigPagination),
         catchError(error => {
            if ((error.indexOf(DPSAPI.ERROR_EXCEPTION_401) != -1 && error.indexOf(DPSAPI.ERROR_EXCEPTION_401_URL) != -1) || (error.indexOf(DPSAPI.ERROR_EXCEPTION_500) != -1 && error.indexOf(DPSAPI.ERROR_EXCEPTION_500_URL) != -1)) {
               throw Error(error);
            }

            const errorOpenApi = this.injector.get(ErrorOpenApiService);
            errorOpenApi.routingCode(error);
            return of(DPSAPI.ERROR);
         })
      )
   }


   /**
   * @param projectname 
   * @param version 
   * @param option 
   * @param page Specifies the page count. More infos see: \&#39;#/components/parameters/Page\&#39;
   * @param limit max count of \&#39;result\&#39; array items. To get the next items see: \&#39;#/components/parameters/Page\&#39;
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */

   public dPSDesignV2ExternCommunicationLoadTextProjectnameVersionOptionGet (identifier: object, payload: object, page?: boolean, pagenr?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<ResponseV2ExternDesignText[] | string>
   {

      if (payload === null || payload === undefined) {
         throw new Error('Required parameter payload was null or undefined when calling dPSDesignV2ExternCommunicationLoadTextProjectnameVersionOptionGet.');
      }
      if (payload === null || payload === undefined) {
         throw new Error('Required parameter payload was null or undefined when calling dPSDesignV2ExternCommunicationLoadTextProjectnameVersionOptionGet.');
      }
      if (payload === null || payload === undefined) {
         throw new Error('Required parameter payload was null or undefined when calling dPSDesignV2ExternCommunicationLoadTextProjectnameVersionOptionGet.');
      }

 
      let authMethods: string[] = []; 
      authMethods.push("ClientName");
      authMethods.push("Secret");

      const headers = authMethods.filter(elem => elem == DPSAPI.AUTHEXTERNUSER).length > 0 ? {[DPSAPI.HEADER_AUTH]: DPSAPI.HEADER_AUTH_PREFIX + sessionStorage.getItem(DPSAPI.SESSIONINFO_KEY_ACCESS)} : {};
      let save = Object.values(identifier);

      let commandUrl = '/DPS/design/v2/extern/communication/load/text/${this.configuration.encodeParam({name: &quot;projectname&quot;, value: projectname, in: &quot;path&quot;, style: &quot;simple&quot;, explode: false, dataType: &quot;string&quot;, dataFormat: &quot;string&quot;})}/${this.configuration.encodeParam({name: &quot;version&quot;, value: version, in: &quot;path&quot;, style: &quot;simple&quot;, explode: false, dataType: &quot;string&quot;, dataFormat: &quot;string&quot;})}/${this.configuration.encodeParam({name: &quot;option&quot;, value: option, in: &quot;path&quot;, style: &quot;simple&quot;, explode: false, dataType: &quot;string&quot;, dataFormat: &quot;string&quot;})}'; 
      if (commandUrl[0] == '/') {
         commandUrl = commandUrl.substring(1); 
      }
      commandUrl = commandUrl.split('/').map(item => item.includes('${this.configuration.encodeParam') ? save.shift() : item).join('/') 
      commandUrl += `?page=${pagenr ?? '0'}&limit=1000`

      return this._dPSDesignV2ExternCommunicationLoadTextProjectnameVersionOptionGet(commandUrl, headers, payload).pipe (
         map(response => {
            if ((response as IStringIndex)["_links"] && !(response as IStringIndex)['_links']["next"]) return (response as IStringIndex)["result"];
            else return response;
         }),
         expand((response: GETResponseV2ExternDesignTextPagination | string, index) => {      
            if (typeof response == 'string' && response == DPSAPI.ERROR) return of(response);
            const el = response['_links' as keyof typeof response];
            if (el) {
               let nextUrl = el['next' as keyof typeof el] as string | undefined;   
               if (!!nextUrl) return  this._dPSDesignV2ExternCommunicationLoadTextProjectnameVersionOptionGet(nextUrl.split('API/OAS/')[1], headers, payload);
               else if (index == 0) return of((response as IStringIndex)["result"]);
               else return of(response);   
            }
            else return of(response);
         }),
         takeWhile(value => (value as IStringIndex)['_links'] && (value as IStringIndex)['_links']["next"], true),
         reduce((all, current) => { 
            const el = (current as IStringIndex)['_links'];
            if (!!el) {
               if ((all as IStringIndex)['result'] == undefined) (all as IStringIndex)['result' ] = [];
               if (!Array.isArray((all as IStringIndex)['result'])) return Object.assign({}, all, current); 
               else if (!Array.isArray((current as IStringIndex)['result'])) return Object.assign({}, all, current);
               else (all as IStringIndex)['result'].push(...(current as IStringIndex)['result']!)
                  
               return Object.assign([], (all as IStringIndex)["result"]);
            } else return Object.assign({}, all, current);
         }),
         catchError(error => {
            return of('ERROR')
         })   
      )
   }

   private _dPSDesignV2ExternCommunicationLoadTextProjectnameVersionOptionGet (commandUrl: string, headers: IAuthorizationHeader, payload: object): Observable<string | GETResponseV2ExternDesignTextPagination> {
      return from<Observable<string>>(dps_api.invoke("open_api", JSON.stringify({verb: 'get', command: commandUrl, headers: headers, json: JSON.stringify(payload)}),15000)).pipe(
         map(response => JSON.parse(response) as GETResponseV2ExternDesignTextPagination),
         catchError(error => {
            if ((error.indexOf(DPSAPI.ERROR_EXCEPTION_401) != -1 && error.indexOf(DPSAPI.ERROR_EXCEPTION_401_URL) != -1) || (error.indexOf(DPSAPI.ERROR_EXCEPTION_500) != -1 && error.indexOf(DPSAPI.ERROR_EXCEPTION_500_URL) != -1)) {
               throw Error(error);
            }

            const errorOpenApi = this.injector.get(ErrorOpenApiService);
            errorOpenApi.routingCode(error);
            return of(DPSAPI.ERROR);
         })
      )
   }


   /**
   * @param projectname 
   * @param version 
   * @param option 
   * @param page Specifies the page count. More infos see: \&#39;#/components/parameters/Page\&#39;
   * @param limit max count of \&#39;result\&#39; array items. To get the next items see: \&#39;#/components/parameters/Page\&#39;
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */

   public dPSDesignV2ExternCommunicationLoadTypographyProjectnameVersionOptionGet (identifier: object, payload: object, page?: boolean, pagenr?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<ResponseV2ExternDesignTypography[] | string>
   {

      if (payload === null || payload === undefined) {
         throw new Error('Required parameter payload was null or undefined when calling dPSDesignV2ExternCommunicationLoadTypographyProjectnameVersionOptionGet.');
      }
      if (payload === null || payload === undefined) {
         throw new Error('Required parameter payload was null or undefined when calling dPSDesignV2ExternCommunicationLoadTypographyProjectnameVersionOptionGet.');
      }
      if (payload === null || payload === undefined) {
         throw new Error('Required parameter payload was null or undefined when calling dPSDesignV2ExternCommunicationLoadTypographyProjectnameVersionOptionGet.');
      }

 
      let authMethods: string[] = []; 
      authMethods.push("ClientName");
      authMethods.push("Secret");

      const headers = authMethods.filter(elem => elem == DPSAPI.AUTHEXTERNUSER).length > 0 ? {[DPSAPI.HEADER_AUTH]: DPSAPI.HEADER_AUTH_PREFIX + sessionStorage.getItem(DPSAPI.SESSIONINFO_KEY_ACCESS)} : {};
      let save = Object.values(identifier);

      let commandUrl = '/DPS/design/v2/extern/communication/load/typography/${this.configuration.encodeParam({name: &quot;projectname&quot;, value: projectname, in: &quot;path&quot;, style: &quot;simple&quot;, explode: false, dataType: &quot;string&quot;, dataFormat: &quot;string&quot;})}/${this.configuration.encodeParam({name: &quot;version&quot;, value: version, in: &quot;path&quot;, style: &quot;simple&quot;, explode: false, dataType: &quot;string&quot;, dataFormat: &quot;string&quot;})}/${this.configuration.encodeParam({name: &quot;option&quot;, value: option, in: &quot;path&quot;, style: &quot;simple&quot;, explode: false, dataType: &quot;string&quot;, dataFormat: &quot;string&quot;})}'; 
      if (commandUrl[0] == '/') {
         commandUrl = commandUrl.substring(1); 
      }
      commandUrl = commandUrl.split('/').map(item => item.includes('${this.configuration.encodeParam') ? save.shift() : item).join('/') 
      commandUrl += `?page=${pagenr ?? '0'}&limit=1000`

      return this._dPSDesignV2ExternCommunicationLoadTypographyProjectnameVersionOptionGet(commandUrl, headers, payload).pipe (
         map(response => {
            if ((response as IStringIndex)["_links"] && !(response as IStringIndex)['_links']["next"]) return (response as IStringIndex)["result"];
            else return response;
         }),
         expand((response: GETResponseV2ExternDesignTypographyPagination | string, index) => {      
            if (typeof response == 'string' && response == DPSAPI.ERROR) return of(response);
            const el = response['_links' as keyof typeof response];
            if (el) {
               let nextUrl = el['next' as keyof typeof el] as string | undefined;   
               if (!!nextUrl) return  this._dPSDesignV2ExternCommunicationLoadTypographyProjectnameVersionOptionGet(nextUrl.split('API/OAS/')[1], headers, payload);
               else if (index == 0) return of((response as IStringIndex)["result"]);
               else return of(response);   
            }
            else return of(response);
         }),
         takeWhile(value => (value as IStringIndex)['_links'] && (value as IStringIndex)['_links']["next"], true),
         reduce((all, current) => { 
            const el = (current as IStringIndex)['_links'];
            if (!!el) {
               if ((all as IStringIndex)['result'] == undefined) (all as IStringIndex)['result' ] = [];
               if (!Array.isArray((all as IStringIndex)['result'])) return Object.assign({}, all, current); 
               else if (!Array.isArray((current as IStringIndex)['result'])) return Object.assign({}, all, current);
               else (all as IStringIndex)['result'].push(...(current as IStringIndex)['result']!)
                  
               return Object.assign([], (all as IStringIndex)["result"]);
            } else return Object.assign({}, all, current);
         }),
         catchError(error => {
            return of('ERROR')
         })   
      )
   }

   private _dPSDesignV2ExternCommunicationLoadTypographyProjectnameVersionOptionGet (commandUrl: string, headers: IAuthorizationHeader, payload: object): Observable<string | GETResponseV2ExternDesignTypographyPagination> {
      return from<Observable<string>>(dps_api.invoke("open_api", JSON.stringify({verb: 'get', command: commandUrl, headers: headers, json: JSON.stringify(payload)}),15000)).pipe(
         map(response => JSON.parse(response) as GETResponseV2ExternDesignTypographyPagination),
         catchError(error => {
            if ((error.indexOf(DPSAPI.ERROR_EXCEPTION_401) != -1 && error.indexOf(DPSAPI.ERROR_EXCEPTION_401_URL) != -1) || (error.indexOf(DPSAPI.ERROR_EXCEPTION_500) != -1 && error.indexOf(DPSAPI.ERROR_EXCEPTION_500_URL) != -1)) {
               throw Error(error);
            }

            const errorOpenApi = this.injector.get(ErrorOpenApiService);
            errorOpenApi.routingCode(error);
            return of(DPSAPI.ERROR);
         })
      )
   }


   /**
   * @param projectname 
   * @param version 
   * @param option 
   * @param page Specifies the page count. More infos see: \&#39;#/components/parameters/Page\&#39;
   * @param limit max count of \&#39;result\&#39; array items. To get the next items see: \&#39;#/components/parameters/Page\&#39;
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */

   public dPSDesignV2InternCommunicationLoadColorProjectnameVersionOptionGet (identifier: object, payload: object, page?: boolean, pagenr?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<ResponseV2InternDesignColor[] | string>
   {

      if (payload === null || payload === undefined) {
         throw new Error('Required parameter payload was null or undefined when calling dPSDesignV2InternCommunicationLoadColorProjectnameVersionOptionGet.');
      }
      if (payload === null || payload === undefined) {
         throw new Error('Required parameter payload was null or undefined when calling dPSDesignV2InternCommunicationLoadColorProjectnameVersionOptionGet.');
      }
      if (payload === null || payload === undefined) {
         throw new Error('Required parameter payload was null or undefined when calling dPSDesignV2InternCommunicationLoadColorProjectnameVersionOptionGet.');
      }

 
      let authMethods: string[] = []; 
      authMethods.push("ClientName");
      authMethods.push("User");

      const headers = authMethods.filter(elem => elem == DPSAPI.AUTHEXTERNUSER).length > 0 ? {[DPSAPI.HEADER_AUTH]: DPSAPI.HEADER_AUTH_PREFIX + sessionStorage.getItem(DPSAPI.SESSIONINFO_KEY_ACCESS)} : {};
      let save = Object.values(identifier);

      let commandUrl = '/DPS/design/v2/intern/communication/load/color/${this.configuration.encodeParam({name: &quot;projectname&quot;, value: projectname, in: &quot;path&quot;, style: &quot;simple&quot;, explode: false, dataType: &quot;string&quot;, dataFormat: &quot;string&quot;})}/${this.configuration.encodeParam({name: &quot;version&quot;, value: version, in: &quot;path&quot;, style: &quot;simple&quot;, explode: false, dataType: &quot;string&quot;, dataFormat: &quot;string&quot;})}/${this.configuration.encodeParam({name: &quot;option&quot;, value: option, in: &quot;path&quot;, style: &quot;simple&quot;, explode: false, dataType: &quot;string&quot;, dataFormat: &quot;string&quot;})}'; 
      if (commandUrl[0] == '/') {
         commandUrl = commandUrl.substring(1); 
      }
      commandUrl = commandUrl.split('/').map(item => item.includes('${this.configuration.encodeParam') ? save.shift() : item).join('/') 
      commandUrl += `?page=${pagenr ?? '0'}&limit=1000`

      return this._dPSDesignV2InternCommunicationLoadColorProjectnameVersionOptionGet(commandUrl, headers, payload).pipe (
         map(response => {
            if ((response as IStringIndex)["_links"] && !(response as IStringIndex)['_links']["next"]) return (response as IStringIndex)["result"];
            else return response;
         }),
         expand((response: GETResponseV2InternDesignColorPagination | string, index) => {      
            if (typeof response == 'string' && response == DPSAPI.ERROR) return of(response);
            const el = response['_links' as keyof typeof response];
            if (el) {
               let nextUrl = el['next' as keyof typeof el] as string | undefined;   
               if (!!nextUrl) return  this._dPSDesignV2InternCommunicationLoadColorProjectnameVersionOptionGet(nextUrl.split('API/OAS/')[1], headers, payload);
               else if (index == 0) return of((response as IStringIndex)["result"]);
               else return of(response);   
            }
            else return of(response);
         }),
         takeWhile(value => (value as IStringIndex)['_links'] && (value as IStringIndex)['_links']["next"], true),
         reduce((all, current) => { 
            const el = (current as IStringIndex)['_links'];
            if (!!el) {
               if ((all as IStringIndex)['result'] == undefined) (all as IStringIndex)['result' ] = [];
               if (!Array.isArray((all as IStringIndex)['result'])) return Object.assign({}, all, current); 
               else if (!Array.isArray((current as IStringIndex)['result'])) return Object.assign({}, all, current);
               else (all as IStringIndex)['result'].push(...(current as IStringIndex)['result']!)
                  
               return Object.assign([], (all as IStringIndex)["result"]);
            } else return Object.assign({}, all, current);
         }),
         catchError(error => {
            return of('ERROR')
         })   
      )
   }

   private _dPSDesignV2InternCommunicationLoadColorProjectnameVersionOptionGet (commandUrl: string, headers: IAuthorizationHeader, payload: object): Observable<string | GETResponseV2InternDesignColorPagination> {
      return from<Observable<string>>(dps_api.invoke("open_api", JSON.stringify({verb: 'get', command: commandUrl, headers: headers, json: JSON.stringify(payload)}),15000)).pipe(
         map(response => JSON.parse(response) as GETResponseV2InternDesignColorPagination),
         catchError(error => {
            if ((error.indexOf(DPSAPI.ERROR_EXCEPTION_401) != -1 && error.indexOf(DPSAPI.ERROR_EXCEPTION_401_URL) != -1) || (error.indexOf(DPSAPI.ERROR_EXCEPTION_500) != -1 && error.indexOf(DPSAPI.ERROR_EXCEPTION_500_URL) != -1)) {
               throw Error(error);
            }

            const errorOpenApi = this.injector.get(ErrorOpenApiService);
            errorOpenApi.routingCode(error);
            return of(DPSAPI.ERROR);
         })
      )
   }


   /**
   * @param projectname 
   * @param version 
   * @param option 
   * @param page Specifies the page count. More infos see: \&#39;#/components/parameters/Page\&#39;
   * @param limit max count of \&#39;result\&#39; array items. To get the next items see: \&#39;#/components/parameters/Page\&#39;
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */

   public dPSDesignV2InternCommunicationLoadConfigProjectnameVersionOptionGet (identifier: object, payload: object, page?: boolean, pagenr?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<ResponseV2InternDesignConfig[] | string>
   {

      if (payload === null || payload === undefined) {
         throw new Error('Required parameter payload was null or undefined when calling dPSDesignV2InternCommunicationLoadConfigProjectnameVersionOptionGet.');
      }
      if (payload === null || payload === undefined) {
         throw new Error('Required parameter payload was null or undefined when calling dPSDesignV2InternCommunicationLoadConfigProjectnameVersionOptionGet.');
      }
      if (payload === null || payload === undefined) {
         throw new Error('Required parameter payload was null or undefined when calling dPSDesignV2InternCommunicationLoadConfigProjectnameVersionOptionGet.');
      }

 
      let authMethods: string[] = []; 
      authMethods.push("ClientName");
      authMethods.push("User");

      const headers = authMethods.filter(elem => elem == DPSAPI.AUTHEXTERNUSER).length > 0 ? {[DPSAPI.HEADER_AUTH]: DPSAPI.HEADER_AUTH_PREFIX + sessionStorage.getItem(DPSAPI.SESSIONINFO_KEY_ACCESS)} : {};
      let save = Object.values(identifier);

      let commandUrl = '/DPS/design/v2/intern/communication/load/config/${this.configuration.encodeParam({name: &quot;projectname&quot;, value: projectname, in: &quot;path&quot;, style: &quot;simple&quot;, explode: false, dataType: &quot;string&quot;, dataFormat: &quot;string&quot;})}/${this.configuration.encodeParam({name: &quot;version&quot;, value: version, in: &quot;path&quot;, style: &quot;simple&quot;, explode: false, dataType: &quot;string&quot;, dataFormat: &quot;string&quot;})}/${this.configuration.encodeParam({name: &quot;option&quot;, value: option, in: &quot;path&quot;, style: &quot;simple&quot;, explode: false, dataType: &quot;string&quot;, dataFormat: &quot;string&quot;})}'; 
      if (commandUrl[0] == '/') {
         commandUrl = commandUrl.substring(1); 
      }
      commandUrl = commandUrl.split('/').map(item => item.includes('${this.configuration.encodeParam') ? save.shift() : item).join('/') 
      commandUrl += `?page=${pagenr ?? '0'}&limit=1000`

      return this._dPSDesignV2InternCommunicationLoadConfigProjectnameVersionOptionGet(commandUrl, headers, payload).pipe (
         map(response => {
            if ((response as IStringIndex)["_links"] && !(response as IStringIndex)['_links']["next"]) return (response as IStringIndex)["result"];
            else return response;
         }),
         expand((response: GETResponseV2InternDesignConfigPagination | string, index) => {      
            if (typeof response == 'string' && response == DPSAPI.ERROR) return of(response);
            const el = response['_links' as keyof typeof response];
            if (el) {
               let nextUrl = el['next' as keyof typeof el] as string | undefined;   
               if (!!nextUrl) return  this._dPSDesignV2InternCommunicationLoadConfigProjectnameVersionOptionGet(nextUrl.split('API/OAS/')[1], headers, payload);
               else if (index == 0) return of((response as IStringIndex)["result"]);
               else return of(response);   
            }
            else return of(response);
         }),
         takeWhile(value => (value as IStringIndex)['_links'] && (value as IStringIndex)['_links']["next"], true),
         reduce((all, current) => { 
            const el = (current as IStringIndex)['_links'];
            if (!!el) {
               if ((all as IStringIndex)['result'] == undefined) (all as IStringIndex)['result' ] = [];
               if (!Array.isArray((all as IStringIndex)['result'])) return Object.assign({}, all, current); 
               else if (!Array.isArray((current as IStringIndex)['result'])) return Object.assign({}, all, current);
               else (all as IStringIndex)['result'].push(...(current as IStringIndex)['result']!)
                  
               return Object.assign([], (all as IStringIndex)["result"]);
            } else return Object.assign({}, all, current);
         }),
         catchError(error => {
            return of('ERROR')
         })   
      )
   }

   private _dPSDesignV2InternCommunicationLoadConfigProjectnameVersionOptionGet (commandUrl: string, headers: IAuthorizationHeader, payload: object): Observable<string | GETResponseV2InternDesignConfigPagination> {
      return from<Observable<string>>(dps_api.invoke("open_api", JSON.stringify({verb: 'get', command: commandUrl, headers: headers, json: JSON.stringify(payload)}),15000)).pipe(
         map(response => JSON.parse(response) as GETResponseV2InternDesignConfigPagination),
         catchError(error => {
            if ((error.indexOf(DPSAPI.ERROR_EXCEPTION_401) != -1 && error.indexOf(DPSAPI.ERROR_EXCEPTION_401_URL) != -1) || (error.indexOf(DPSAPI.ERROR_EXCEPTION_500) != -1 && error.indexOf(DPSAPI.ERROR_EXCEPTION_500_URL) != -1)) {
               throw Error(error);
            }

            const errorOpenApi = this.injector.get(ErrorOpenApiService);
            errorOpenApi.routingCode(error);
            return of(DPSAPI.ERROR);
         })
      )
   }


   /**
   * @param projectname 
   * @param version 
   * @param option 
   * @param page Specifies the page count. More infos see: \&#39;#/components/parameters/Page\&#39;
   * @param limit max count of \&#39;result\&#39; array items. To get the next items see: \&#39;#/components/parameters/Page\&#39;
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */

   public dPSDesignV2InternCommunicationLoadTextProjectnameVersionOptionGet (identifier: object, payload: object, page?: boolean, pagenr?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<ResponseV2InternDesignText[] | string>
   {

      if (payload === null || payload === undefined) {
         throw new Error('Required parameter payload was null or undefined when calling dPSDesignV2InternCommunicationLoadTextProjectnameVersionOptionGet.');
      }
      if (payload === null || payload === undefined) {
         throw new Error('Required parameter payload was null or undefined when calling dPSDesignV2InternCommunicationLoadTextProjectnameVersionOptionGet.');
      }
      if (payload === null || payload === undefined) {
         throw new Error('Required parameter payload was null or undefined when calling dPSDesignV2InternCommunicationLoadTextProjectnameVersionOptionGet.');
      }

 
      let authMethods: string[] = []; 
      authMethods.push("ClientName");
      authMethods.push("User");

      const headers = authMethods.filter(elem => elem == DPSAPI.AUTHEXTERNUSER).length > 0 ? {[DPSAPI.HEADER_AUTH]: DPSAPI.HEADER_AUTH_PREFIX + sessionStorage.getItem(DPSAPI.SESSIONINFO_KEY_ACCESS)} : {};
      let save = Object.values(identifier);

      let commandUrl = '/DPS/design/v2/intern/communication/load/text/${this.configuration.encodeParam({name: &quot;projectname&quot;, value: projectname, in: &quot;path&quot;, style: &quot;simple&quot;, explode: false, dataType: &quot;string&quot;, dataFormat: &quot;string&quot;})}/${this.configuration.encodeParam({name: &quot;version&quot;, value: version, in: &quot;path&quot;, style: &quot;simple&quot;, explode: false, dataType: &quot;string&quot;, dataFormat: &quot;string&quot;})}/${this.configuration.encodeParam({name: &quot;option&quot;, value: option, in: &quot;path&quot;, style: &quot;simple&quot;, explode: false, dataType: &quot;string&quot;, dataFormat: &quot;string&quot;})}'; 
      if (commandUrl[0] == '/') {
         commandUrl = commandUrl.substring(1); 
      }
      commandUrl = commandUrl.split('/').map(item => item.includes('${this.configuration.encodeParam') ? save.shift() : item).join('/') 
      commandUrl += `?page=${pagenr ?? '0'}&limit=1000`

      return this._dPSDesignV2InternCommunicationLoadTextProjectnameVersionOptionGet(commandUrl, headers, payload).pipe (
         map(response => {
            if ((response as IStringIndex)["_links"] && !(response as IStringIndex)['_links']["next"]) return (response as IStringIndex)["result"];
            else return response;
         }),
         expand((response: GETResponseV2InternDesignTextPagination | string, index) => {      
            if (typeof response == 'string' && response == DPSAPI.ERROR) return of(response);
            const el = response['_links' as keyof typeof response];
            if (el) {
               let nextUrl = el['next' as keyof typeof el] as string | undefined;   
               if (!!nextUrl) return  this._dPSDesignV2InternCommunicationLoadTextProjectnameVersionOptionGet(nextUrl.split('API/OAS/')[1], headers, payload);
               else if (index == 0) return of((response as IStringIndex)["result"]);
               else return of(response);   
            }
            else return of(response);
         }),
         takeWhile(value => (value as IStringIndex)['_links'] && (value as IStringIndex)['_links']["next"], true),
         reduce((all, current) => { 
            const el = (current as IStringIndex)['_links'];
            if (!!el) {
               if ((all as IStringIndex)['result'] == undefined) (all as IStringIndex)['result' ] = [];
               if (!Array.isArray((all as IStringIndex)['result'])) return Object.assign({}, all, current); 
               else if (!Array.isArray((current as IStringIndex)['result'])) return Object.assign({}, all, current);
               else (all as IStringIndex)['result'].push(...(current as IStringIndex)['result']!)
                  
               return Object.assign([], (all as IStringIndex)["result"]);
            } else return Object.assign({}, all, current);
         }),
         catchError(error => {
            return of('ERROR')
         })   
      )
   }

   private _dPSDesignV2InternCommunicationLoadTextProjectnameVersionOptionGet (commandUrl: string, headers: IAuthorizationHeader, payload: object): Observable<string | GETResponseV2InternDesignTextPagination> {
      return from<Observable<string>>(dps_api.invoke("open_api", JSON.stringify({verb: 'get', command: commandUrl, headers: headers, json: JSON.stringify(payload)}),15000)).pipe(
         map(response => JSON.parse(response) as GETResponseV2InternDesignTextPagination),
         catchError(error => {
            if ((error.indexOf(DPSAPI.ERROR_EXCEPTION_401) != -1 && error.indexOf(DPSAPI.ERROR_EXCEPTION_401_URL) != -1) || (error.indexOf(DPSAPI.ERROR_EXCEPTION_500) != -1 && error.indexOf(DPSAPI.ERROR_EXCEPTION_500_URL) != -1)) {
               throw Error(error);
            }

            const errorOpenApi = this.injector.get(ErrorOpenApiService);
            errorOpenApi.routingCode(error);
            return of(DPSAPI.ERROR);
         })
      )
   }


   /**
   * @param projectname 
   * @param version 
   * @param option 
   * @param page Specifies the page count. More infos see: \&#39;#/components/parameters/Page\&#39;
   * @param limit max count of \&#39;result\&#39; array items. To get the next items see: \&#39;#/components/parameters/Page\&#39;
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */

   public dPSDesignV2InternCommunicationLoadTypographyProjectnameVersionOptionGet (identifier: object, payload: object, page?: boolean, pagenr?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<ResponseV2InternDesignTypography[] | string>
   {

      if (payload === null || payload === undefined) {
         throw new Error('Required parameter payload was null or undefined when calling dPSDesignV2InternCommunicationLoadTypographyProjectnameVersionOptionGet.');
      }
      if (payload === null || payload === undefined) {
         throw new Error('Required parameter payload was null or undefined when calling dPSDesignV2InternCommunicationLoadTypographyProjectnameVersionOptionGet.');
      }
      if (payload === null || payload === undefined) {
         throw new Error('Required parameter payload was null or undefined when calling dPSDesignV2InternCommunicationLoadTypographyProjectnameVersionOptionGet.');
      }

 
      let authMethods: string[] = []; 
      authMethods.push("ClientName");
      authMethods.push("User");

      const headers = authMethods.filter(elem => elem == DPSAPI.AUTHEXTERNUSER).length > 0 ? {[DPSAPI.HEADER_AUTH]: DPSAPI.HEADER_AUTH_PREFIX + sessionStorage.getItem(DPSAPI.SESSIONINFO_KEY_ACCESS)} : {};
      let save = Object.values(identifier);

      let commandUrl = '/DPS/design/v2/intern/communication/load/typography/${this.configuration.encodeParam({name: &quot;projectname&quot;, value: projectname, in: &quot;path&quot;, style: &quot;simple&quot;, explode: false, dataType: &quot;string&quot;, dataFormat: &quot;string&quot;})}/${this.configuration.encodeParam({name: &quot;version&quot;, value: version, in: &quot;path&quot;, style: &quot;simple&quot;, explode: false, dataType: &quot;string&quot;, dataFormat: &quot;string&quot;})}/${this.configuration.encodeParam({name: &quot;option&quot;, value: option, in: &quot;path&quot;, style: &quot;simple&quot;, explode: false, dataType: &quot;string&quot;, dataFormat: &quot;string&quot;})}'; 
      if (commandUrl[0] == '/') {
         commandUrl = commandUrl.substring(1); 
      }
      commandUrl = commandUrl.split('/').map(item => item.includes('${this.configuration.encodeParam') ? save.shift() : item).join('/') 
      commandUrl += `?page=${pagenr ?? '0'}&limit=1000`

      return this._dPSDesignV2InternCommunicationLoadTypographyProjectnameVersionOptionGet(commandUrl, headers, payload).pipe (
         map(response => {
            if ((response as IStringIndex)["_links"] && !(response as IStringIndex)['_links']["next"]) return (response as IStringIndex)["result"];
            else return response;
         }),
         expand((response: GETResponseV2InternDesignTypographyPagination | string, index) => {      
            if (typeof response == 'string' && response == DPSAPI.ERROR) return of(response);
            const el = response['_links' as keyof typeof response];
            if (el) {
               let nextUrl = el['next' as keyof typeof el] as string | undefined;   
               if (!!nextUrl) return  this._dPSDesignV2InternCommunicationLoadTypographyProjectnameVersionOptionGet(nextUrl.split('API/OAS/')[1], headers, payload);
               else if (index == 0) return of((response as IStringIndex)["result"]);
               else return of(response);   
            }
            else return of(response);
         }),
         takeWhile(value => (value as IStringIndex)['_links'] && (value as IStringIndex)['_links']["next"], true),
         reduce((all, current) => { 
            const el = (current as IStringIndex)['_links'];
            if (!!el) {
               if ((all as IStringIndex)['result'] == undefined) (all as IStringIndex)['result' ] = [];
               if (!Array.isArray((all as IStringIndex)['result'])) return Object.assign({}, all, current); 
               else if (!Array.isArray((current as IStringIndex)['result'])) return Object.assign({}, all, current);
               else (all as IStringIndex)['result'].push(...(current as IStringIndex)['result']!)
                  
               return Object.assign([], (all as IStringIndex)["result"]);
            } else return Object.assign({}, all, current);
         }),
         catchError(error => {
            return of('ERROR')
         })   
      )
   }

   private _dPSDesignV2InternCommunicationLoadTypographyProjectnameVersionOptionGet (commandUrl: string, headers: IAuthorizationHeader, payload: object): Observable<string | GETResponseV2InternDesignTypographyPagination> {
      return from<Observable<string>>(dps_api.invoke("open_api", JSON.stringify({verb: 'get', command: commandUrl, headers: headers, json: JSON.stringify(payload)}),15000)).pipe(
         map(response => JSON.parse(response) as GETResponseV2InternDesignTypographyPagination),
         catchError(error => {
            if ((error.indexOf(DPSAPI.ERROR_EXCEPTION_401) != -1 && error.indexOf(DPSAPI.ERROR_EXCEPTION_401_URL) != -1) || (error.indexOf(DPSAPI.ERROR_EXCEPTION_500) != -1 && error.indexOf(DPSAPI.ERROR_EXCEPTION_500_URL) != -1)) {
               throw Error(error);
            }

            const errorOpenApi = this.injector.get(ErrorOpenApiService);
            errorOpenApi.routingCode(error);
            return of(DPSAPI.ERROR);
         })
      )
   }


   /**
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */

   public dPSOKDesignV1VersionGet (identifier: object, payload: object, page?: boolean, pagenr?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<ResponseDesignVersion | string>
   {


 
      let authMethods: string[] = []; 
      authMethods.push("ClientName");
      authMethods.push("Secret");

      const headers = authMethods.filter(elem => elem == DPSAPI.AUTHEXTERNUSER).length > 0 ? {[DPSAPI.HEADER_AUTH]: DPSAPI.HEADER_AUTH_PREFIX + sessionStorage.getItem(DPSAPI.SESSIONINFO_KEY_ACCESS)} : {};
      let save = Object.values(identifier);

      let commandUrl = '/DPS/OK/design/v1/version'; 
      if (commandUrl[0] == '/') {
         commandUrl = commandUrl.substring(1); 
      }
      commandUrl = commandUrl.split('/').map(item => item.includes('${this.configuration.encodeParam') ? save.shift() : item).join('/') 
      commandUrl += `?page=${pagenr ?? '0'}&limit=1000`

      return this._dPSOKDesignV1VersionGet(commandUrl, headers, payload).pipe (
         map(response => {
            if ((response as IStringIndex)["_links"] && !(response as IStringIndex)['_links']["next"]) return (response as IStringIndex)["result"];
            else return response;
         }),
         expand((response: ResponseDesignVersion | string, index) => {      
            if (typeof response == 'string' && response == DPSAPI.ERROR) return of(response);
            const el = response['_links' as keyof typeof response];
            if (el) {
               let nextUrl = el['next' as keyof typeof el] as string | undefined;   
               if (!!nextUrl) return  this._dPSOKDesignV1VersionGet(nextUrl.split('API/OAS/')[1], headers, payload);
               else if (index == 0) return of((response as IStringIndex)["result"]);
               else return of(response);   
            }
            else return of(response);
         }),
         takeWhile(value => (value as IStringIndex)['_links'] && (value as IStringIndex)['_links']["next"], true),
         reduce((all, current) => { 
            const el = (current as IStringIndex)['_links'];
            if (!!el) {
               if ((all as IStringIndex)['result'] == undefined) (all as IStringIndex)['result' ] = [];
               if (!Array.isArray((all as IStringIndex)['result'])) return Object.assign({}, all, current); 
               else if (!Array.isArray((current as IStringIndex)['result'])) return Object.assign({}, all, current);
               else (all as IStringIndex)['result'].push(...(current as IStringIndex)['result']!)
                  
               return Object.assign([], (all as IStringIndex)["result"]);
            } else return Object.assign({}, all, current);
         }),
         catchError(error => {
            return of('ERROR')
         })   
      )
   }

   private _dPSOKDesignV1VersionGet (commandUrl: string, headers: IAuthorizationHeader, payload: object): Observable<string | ResponseDesignVersion> {
      return from<Observable<string>>(dps_api.invoke("open_api", JSON.stringify({verb: 'get', command: commandUrl, headers: headers, json: JSON.stringify(payload)}),15000)).pipe(
         map(response => JSON.parse(response) as ResponseDesignVersion),
         catchError(error => {
            if ((error.indexOf(DPSAPI.ERROR_EXCEPTION_401) != -1 && error.indexOf(DPSAPI.ERROR_EXCEPTION_401_URL) != -1) || (error.indexOf(DPSAPI.ERROR_EXCEPTION_500) != -1 && error.indexOf(DPSAPI.ERROR_EXCEPTION_500_URL) != -1)) {
               throw Error(error);
            }

            const errorOpenApi = this.injector.get(ErrorOpenApiService);
            errorOpenApi.routingCode(error);
            return of(DPSAPI.ERROR);
         })
      )
   }


   /**
   * @param body 
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */

   public dPSVersionV1Post (identifier: object, payload: object, page?: boolean, pagenr?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<POSTDPSVersionV1Response | string>
   {


 
      let authMethods: string[] = []; 
      authMethods.push("ClientName");
      authMethods.push("Secret");

      const headers = authMethods.filter(elem => elem == DPSAPI.AUTHEXTERNUSER).length > 0 ? {[DPSAPI.HEADER_AUTH]: DPSAPI.HEADER_AUTH_PREFIX + sessionStorage.getItem(DPSAPI.SESSIONINFO_KEY_ACCESS)} : {};
      let save = Object.values(identifier);

      let commandUrl = '/DPS/version/v1'; 
      if (commandUrl[0] == '/') {
         commandUrl = commandUrl.substring(1); 
      }
      commandUrl = commandUrl.split('/').map(item => item.includes('${this.configuration.encodeParam') ? save.shift() : item).join('/') 
      commandUrl += `?page=${pagenr ?? '0'}&limit=1000`

      return this._dPSVersionV1Post(commandUrl, headers, payload).pipe (
         map(response => {
            if ((response as IStringIndex)["_links"] && !(response as IStringIndex)['_links']["next"]) return (response as IStringIndex)["result"];
            else return response;
         }),
         expand((response: POSTDPSVersionV1Response | string, index) => {      
            if (typeof response == 'string' && response == DPSAPI.ERROR) return of(response);
            const el = response['_links' as keyof typeof response];
            if (el) {
               let nextUrl = el['next' as keyof typeof el] as string | undefined;   
               if (!!nextUrl) return  this._dPSVersionV1Post(nextUrl.split('API/OAS/')[1], headers, payload);
               else if (index == 0) return of((response as IStringIndex)["result"]);
               else return of(response);   
            }
            else return of(response);
         }),
         takeWhile(value => (value as IStringIndex)['_links'] && (value as IStringIndex)['_links']["next"], true),
         reduce((all, current) => { 
            const el = (current as IStringIndex)['_links'];
            if (!!el) {
               if ((all as IStringIndex)['result'] == undefined) (all as IStringIndex)['result' ] = [];
               if (!Array.isArray((all as IStringIndex)['result'])) return Object.assign({}, all, current); 
               else if (!Array.isArray((current as IStringIndex)['result'])) return Object.assign({}, all, current);
               else (all as IStringIndex)['result'].push(...(current as IStringIndex)['result']!)
                  
               return Object.assign([], (all as IStringIndex)["result"]);
            } else return Object.assign({}, all, current);
         }),
         catchError(error => {
            return of('ERROR')
         })   
      )
   }

   private _dPSVersionV1Post (commandUrl: string, headers: IAuthorizationHeader, payload: object): Observable<string | POSTDPSVersionV1Response> {
      return from<Observable<string>>(dps_api.invoke("open_api", JSON.stringify({verb: 'post', command: commandUrl, headers: headers, json: JSON.stringify(payload)}),15000)).pipe(
         map(response => JSON.parse(response) as POSTDPSVersionV1Response),
         catchError(error => {
            if ((error.indexOf(DPSAPI.ERROR_EXCEPTION_401) != -1 && error.indexOf(DPSAPI.ERROR_EXCEPTION_401_URL) != -1) || (error.indexOf(DPSAPI.ERROR_EXCEPTION_500) != -1 && error.indexOf(DPSAPI.ERROR_EXCEPTION_500_URL) != -1)) {
               throw Error(error);
            }

            const errorOpenApi = this.injector.get(ErrorOpenApiService);
            errorOpenApi.routingCode(error);
            return of(DPSAPI.ERROR);
         })
      )
   }

}

